export const formatSquadName = (squadName: string) => {
  let cleanedName = squadName;
  if (!squadName.includes('squad')) {
    cleanedName = `${squadName}-squad`;
  }

  return cleanedName;
};
